export default __webpack_public_path__ + "static/media/VideoArchive.5b8035b7.svg";